/* eslint-disable react/style-prop-object */
import { useEffect } from "react";
import TotalComponent from "./DashboardTotal/TotalComponent";
import {
  useDashboardChartsQuery,
  useDashboardCountDifferenceQuery,
  useTotalDashboardCountsQuery,
} from "../../../Redux/service/Vehicles/Vehicles";
import { useDispatch } from "react-redux";
import { setTotalCount } from "../../../Redux/service/Vehicles/VehiclesSlice";

export default function DashboardTotal() {
  const dispatch = useDispatch();
  const { data: countDiff } = useDashboardCountDifferenceQuery();
  const { data: chartsData } = useDashboardChartsQuery();
  const { data, isLoading, isError } = useTotalDashboardCountsQuery();

  useEffect(() => {
    dispatch(setTotalCount(data?.totalVehicles));
  }, [dispatch, data?.totalVehicles]);

  const reversedChartsData = chartsData
    ? {
        months: chartsData.months?.slice().reverse(),
        vehicles: chartsData.vehicles?.slice().reverse(),
        drivers: chartsData.drivers?.slice().reverse(),
        users: chartsData.users?.slice().reverse(),
        fuelCosts: chartsData.fuelCosts
          ?.slice()
          .reverse()
          .map((num) => Math.round(num * 100) / 100),
      }
    : {};
  return (
    <>
      <div className="bg-white-rounded">
        <div className="d-flex align-items-center justify-content-between flex-wrap">
          <TotalComponent
            title="Total Vehicles"
            percent={countDiff?.vehicles?.difference}
            number={isLoading ? "Loading..." : `${data?.totalVehicles}`}
            chart="Purplechart"
            color="#A855F7"
            labels={reversedChartsData?.months}
            data={reversedChartsData?.vehicles}
          />
          <div className="vertical-line vertical-line-1"></div>
          <TotalComponent
            title="Total Drivers"
            percent={countDiff?.drivers?.difference}
            number={isLoading ? "Loading..." : `${data?.totalDrivers}`}
            chart="Bluechart"
            color="#3B82F6"
            labels={reversedChartsData?.months}
            data={reversedChartsData?.drivers}
          />
          <div className="vertical-line vertical-line-2"></div>
          <TotalComponent
            title="Total Users"
            percent={countDiff?.users?.difference}
            number={isLoading ? "Loading..." : `${data?.totalUsers}`}
            chart="Redchart"
            color="#EF4444"
            labels={reversedChartsData?.months}
            data={reversedChartsData?.users}
          />
          <div className="vertical-line vertical-line-3"></div>
          <TotalComponent
            title="Fuel Cost"
            percent={countDiff?.fuelCost?.percentageChange}
            number={isLoading ? "Loading..." : `${data?.totalFuelCost}`}
            chart="Greenchart"
            color="#2E9245"
            labels={reversedChartsData?.months}
            data={reversedChartsData?.fuelCosts}
            type="money"
          />
        </div>
      </div>
    </>
  );
}
